export var UsersAndTeamsPaths;
(function (UsersAndTeamsPaths) {
    UsersAndTeamsPaths["users"] = "users";
    UsersAndTeamsPaths["invites"] = "invites";
    UsersAndTeamsPaths["teams"] = "teams";
})(UsersAndTeamsPaths || (UsersAndTeamsPaths = {}));
